<template>
    <el-row class="content_wrap">
        <el-row>
            <el-col :span="24"><div class="grid-content bg-purple-dark u_qiaosui_header"><i class="el-icon-menu"></i>桥隧概况</div></el-col>
        </el-row>
        <div class="u_suidao_body">
            <el-row :gutter="20">
                <!-- 安全状况 -->
                <el-col :span="12">
                    <div class="grid-content bg-purple u_suidao_bg">
                        <div class="u_suidao_title">安全状况</div>
                        <!-- 基本信息 -->
                        <el-row style="border-bottom:1px solid #ddd;">
                            <el-col :span="24">
                                <div class="grid-content bg-purple u_suidao_title_c">
                                    <div style="padding: 6px 0;">基本信息</div>
                                    <div class="u_suidao_intro">隧道名称：{{suidaoName}}</div>
                                    <div class="u_suidao_intro" style="text-indent:2em;">简介：{{suidaoInfoList.description}}</div>
                                    <div class="u_suidao_intro">所属区域：{{suidaoInfoList.section}}</div>
                                    <div class="u_suidao_intro" style="text-indent:2em;">长度：{{suidaoLength}}KM</div>
                                    <div class="u_suidao_intro">通车时间：{{openingTimeName}}</div>
                                    <div class="u_suidao_intro">管理单位：{{suidaoInfoList.managementUnit}}</div>
                                </div>
                            </el-col>
                        </el-row>
                        <!-- 本月运行状态 -->
                        <el-row style="border-bottom:1px solid #ddd;">
                            <el-row>
                                <el-col :span="12">
                                    <div class="grid-content bg-purple" style="padding:20px 30px 0 30px;">
                                        <div>本月运行状态</div>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="grid-content bg-purple" style="padding:12px 12px 0 30px;text-align:right;">
                                        <span style="color:#7F7F7F;font-size:14px;">请选择年月：</span>
                                        <el-date-picker v-model="monthVal" type="month" placeholder="选择月" value-format="yyyy-M" @change="getMonthVal"></el-date-picker>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-col :span="10">
                                <div class="grid-content bg-purple u_suidao_title_c">
                                    <div id="myChart01" style="width:100%;height:220px;"></div>
                                    <div class="u_suidao_score" v-if="this.monthStateList != undefined">技术评分：{{jspfData}}</div>
                                    <div class="u_suidao_score" id="u_zt_bgcolor" v-if="this.monthStateList != undefined">服役状态：{{this.monthStateList.serviceStatusName}}</div>
                                </div>
                            </el-col>
                            <el-col :span="14"><div class="grid-content bg-purple u_suidao_title_c"><div id="myChart02" style="width:100%;height:300px;"></div></div></el-col>
                        </el-row>
                        <!-- 本年技术评分 -->
                        <el-row>
                            <el-row>
                                <el-col :span="12">
                                    <div class="grid-content bg-purple" style="padding:20px 30px 0 30px;">
                                        <div>本年技术评分</div>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="grid-content bg-purple" style="padding:12px 12px 0 30px;text-align:right;">
                                        <span style="color:#7F7F7F;font-size:14px;">请选择年：</span>
                                        <el-date-picker v-model="yearVal" type="year" placeholder="选择月" value-format="yyyy" @change="getYearVal"></el-date-picker>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-col :span="24">
                                <div class="grid-content bg-purple u_suidao_title_c">
                                    <div id="myChart03" style="width:100%;height:260px;"></div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="grid-content bg-purple u_suidao_title_c" @click="viewDetails">
                                    <div class="u_suidao_details">查看详情</div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
                <!-- 消息 -->
                <el-col :span="12">
                    <div class="grid-content bg-purple u_suidao_bg">
                        <div class="u_suidao_title">消息<div>更多消息...</div><div>未读200条消息</div></div>
                        <div class="grid-content bg-purple u_suidao_title_c" style="height:1076px;overflow:hidden;">
                            <marquee direction="up" onMouseOut="this.start()" onMouseOver="this.stop()" scrollamount="2" scrolldelay="0" loop="-1" width="100%" height="100%" hspace="10" vspace="10">
                                <div style="margin-top:-950px;">
                                    <el-row v-for="item in messageList" :key="item.value">
                                        <el-col :span="24">  
                                            <el-row>
                                                <el-col :span="12">
                                                    <div class="grid-content bg-purple u_suidao_info">【数据】{{suidaoName}}</div>
                                                </el-col>
                                                <el-col :span="12">
                                                    <div class="grid-content bg-purple-light u_suidao_info" style="text-align:right;">{{item.dateTime}}</div>
                                                </el-col>
                                            </el-row>
                                            <div class="u_suidao_info_bg">
                                                <el-row>
                                                    <el-col :span="12">
                                                        <div class="grid-content bg-purple u_suidao_info_cn" style="padding-left:50px">{{item.dateTime}}</div>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <div class="grid-content bg-purple-light u_suidao_info_cn" style="text-align:right;padding-right:50px">{{item.systemType}}，{{item.instrumentName}}，{{item.statusName}}</div>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </marquee>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </el-row>
</template>

<script>
import $ from 'jquery'
import axios from "axios"
import * as echarts from 'echarts'
import { mapState,mapMutations } from 'vuex'
export default {
    name: 'bridgeSurvey',
    data() {
        let newDate = localStorage.getItem('newDate')
        return {
            suidaoInfoList: '',
            suidaoInfoOther: [],
            openingTimeName: '',
            suidaoLength: '',
            monthVal: `${newDate.split('/')[0]}-${newDate.split('/')[1]}`,
            yearVal: `${newDate.split('/')[0]}`,
            suidaoName:'',
            messageList: [],
            jspfData: ''
        };
    },
    computed: {
        ...mapState([
            'list',
            'monthStateList',
            'yearScoreList'
        ])
    },
    async created(){
        let self = this
        // 获取隧道的基本信息
        self.TunnelId = localStorage.getItem('TunnelId')
        self.suidaoName = localStorage.getItem('suidaoName')
        const rLoading = this.openLoading()
        // 隧道概况 && 安全状况-基本信息
        await axios.get(`/bridgetunnel/tunnel/${self.TunnelId}/info`)
        .then(function(res) {
            self.suidaoInfoList = res.data
            self.suidaoLength = `${res.data.length.split(' ')[0]} ${res.data.length.split(' ')[1] /1000}`
            self.openingTimeName = res.data.openingTime.split('T')[0]
            rLoading.close()
        })
        let newDate = localStorage.getItem('newDate')
        // 初始化消息列表
        await self.$store.dispatch('getSuidaoInfo')
        // 初始加载本月运行状态、技术评分
        await self.getMonthVal(`${newDate.split('/')[0]}-${newDate.split('/')[1]}`)
        await self.getYearVal(`${newDate.split('/')[0]}`)
        await self.getMessageList()
    },
    mounted: function () {},
    methods: {
        // 本月运行状态
        async getMonthVal(val1){
            const rLoading = this.openLoading()
            $('#myChart01,#myChart02').fadeOut(500)
            $('#myChart01,#myChart02').fadeIn(500)
            let startTime = ''
            if (val1.split('-')[1].length === 1){
                startTime = `${val1.split('-')[0]}-0${val1.split('-')[1]}-01 00:00:00`
            } else {
                startTime = `${val1.split('-')[0]}-${val1.split('-')[1]}-01 00:00:00`
            }
            let endTime = ''
            if (JSON.stringify(val1.split('-')[1] * 1 + 1).length === 1){
                endTime = `${val1.split('-')[0]}-0${val1.split('-')[1] * 1 + 1}-01 00:00:00`
            } else {
                endTime = `${val1.split('-')[0]}-${val1.split('-')[1] * 1 + 1}-01 00:00:00`
            }
            await this.$store.dispatch('getOperationStateInfo', {
                startTime: startTime,
                endTime: endTime
            })
            if (this.monthStateList != undefined){
                this.jspfData = this.monthStateList.technicalScore
                let myCharts01 = echarts.init(document.getElementById(`myChart01`))
                let options01 = {
                    series: [{
                        type: 'gauge',
                        startAngle: 180,
                        endAngle: 0,
                        min: 0,
                        max: 100,
                        splitNumber: 10,
                        radius: '100%',
                        center:['50%', '70%'],
                        axisLine: {
                            lineStyle: {
                                width: 6,
                                color: [
                                    [0.7, 'rgba(91,143,249)'],
                                    [0.9, 'rgba(90,216,166)'],
                                    [1, 'rgba(93,112,146)']
                                ]
                            }
                        },
                        pointer: {
                            offsetCenter: [0, '-30%']
                        },
                        axisLabel: {
                            color: '#464646',
                            fontSize: 12,
                            distance: -45,
                            formatter: function (value) {
                                if (value === 100) {
                                    return '正常'
                                }
                                else if (value === 80) {
                                    return '恶化'
                                }
                                else if (value === 50) {
                                    return '危险'
                                }
                            }
                        },
                        title: {
                            offsetCenter: [0, '-20%'],
                            fontSize: 16
                        },
                        detail: {
                            fontSize: 24,
                            offsetCenter: [0, '2%'],
                            valueAnimation: true,
                            formatter: function (value) {
                                return Math.round(value)
                            }
                        },
                        data: [{
                            name: '分数',
                            value: this.monthStateList.technicalScore
                        }]
                    }]
                };
                let fuyibgcolor = document.getElementById('u_zt_bgcolor')
                if (this.monthStateList.technicalScore > 90){
                    fuyibgcolor.style.background = 'rgba(129,211,248,1)'
                } else if (this.monthStateList.technicalScore < 90 && this.monthStateList.technicalScore > 80){
                    fuyibgcolor.style.background = 'rgba(218,165,32,0.5)'
                } else if (this.monthStateList.technicalScore < 80){
                    fuyibgcolor.style.background = 'rgba(255,0,0,0.5)'
                }
                let failureRateData = [this.monthStateList.ventilationFaultRate, this.monthStateList.lightingFaultRate,this.monthStateList.waterSupplyDrainageFaultRate,this.monthStateList.weakCurrentFaultRate,this.monthStateList.powerSupplyFaultRate,this.monthStateList.fireFightingFaultRate]
                let myCharts02 = echarts.init(document.getElementById(`myChart02`))
                let options02 = {
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['故障率'],
                        bottom: "0"
                    },
                    grid: {
                        left: "10%",
                        right: "1%",
                        top: "6%"
                    },
                    xAxis: {
                        type: 'category',
                        data: ['通风设施','照明设施','给排水设施','弱电设施','供配电设施','消防设施'],
                        axisLabel: {
                            interval:0,
                            rotate:30
                        }
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        name:'故障率',
                        type: 'bar',
                        barWidth : 20,
                        data: failureRateData
                    }]
                };
                myCharts01.setOption(options01)
                myCharts02.setOption(options02)
                window.addEventListener('resize', function () {
                    myCharts01.resize()
                    myCharts02.resize()
                });
            }
            rLoading.close()
        },
        // 本年技术评分
        async getYearVal(val){
            const rLoading = this.openLoading()
            $('#myChart03').fadeOut(200)
            $('#myChart03').fadeIn(200)
            let startTime = `${JSON.parse(val)}-01-01`
            let endTime = `${JSON.parse(val)+1}-01-01`
            await this.$store.dispatch('getSkillScoreInfo', {
                startTime: startTime,
                endTime: endTime
            })
            let TechnicalGradeArr = new Array()
            this.yearScoreList.forEach(ele => {
                TechnicalGradeArr.push(ele.technicalScore)
            })
            let myCharts03 = echarts.init(document.getElementById(`myChart03`))
            let options03 = {
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: '',
                    bottom: "0"
                },
                grid: {
                    left: "8%",
                    right: "1%",
                    top: "5%"
                },
                xAxis: {
                    type: 'category',
                    data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    name:'技术总评分',
                    type: 'line',
                    barWidth : 20,
                    data: TechnicalGradeArr
                }]
            };
            myCharts03.setOption(options03)
            window.addEventListener('resize', function () {
                myCharts03.resize()
            });
            rLoading.close()
        },
        // 消息
        async getMessageList() {
            this.list.forEach(ele => {
                this.messageList.push({
                    dateTime: ele.dateTime.split('.')[0].replace('T', ' '),
                    systemType: ele.systemType,
                    instrumentName: ele.instrumentName,
                    statusName: ele.statusName
                })
            })
        },
        // 查看详情
         async viewDetails(){
            this.$router.push('/bridgeDetails')
         }
    }
};
</script>
